$('header a.headline').on('mouseenter', function() {
    $('nav#menu').addClass('show')

    $('#nav-wrapper').on('mouseleave', function() {
        $('nav#menu').removeClass('show')
    })
})

$('select#menu').on('change', function(e) {
    window.location.href = e.target.value
})